Object.defineProperty(exports, "__esModule", { value: true });
exports.DeepWeakMap = void 0;
const object_path_1 = require("object-path");
function flattenPaths(paths) {
    return paths.reduce((accumulatedPath, nextPath) => {
        if (Array.isArray(nextPath)) {
            return [...accumulatedPath, ...nextPath.map((pathPart) => `${pathPart}`)];
        }
        return [...accumulatedPath, `${nextPath}`];
    }, []);
}
class DeepWeakMap {
    constructor() {
        this.map = new WeakMap();
    }
    isEmpty(target) {
        return !Object.keys(this.getAll(target)).length;
    }
    getAll(target) {
        const { map } = this;
        if (!map.has(target)) {
            const empty = {};
            map.set(target, empty);
        }
        return map.get(target);
    }
    set(target, path, value) {
        object_path_1.set(this.getAll(target), path, value);
    }
    get(target, ...paths) {
        const path = flattenPaths(paths);
        return object_path_1.get(this.getAll(target), path);
    }
    has(target, ...paths) {
        const path = flattenPaths(paths);
        return !!this.get(target, path);
    }
}
exports.DeepWeakMap = DeepWeakMap;
//# sourceMappingURL=DeepWeakMap.js.map